import React, { useState, useEffect, memo, useContext } from "react";

// context
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// components
import Tabs from "./Tabs";

// utils
import { api } from "bodycodi/cmap/app/js/api";
import { changeDateFormat, getDwk, moneyFormatter, timeFormat } from "bodycodi/cmap/app/js/common";

const ContractDetails = ({ seqNewSettlementPayroll }: any) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [overviewDetails, setOverviewDetails] = useState({});
  const [tabDetails, setTabDetails] = useState({});

  const fetchContractDetails = async () => {
    dispatch({ type: "LOADING_START" });
    try {
      await api.get(`/payroll/settings/${seqNewSettlementPayroll}`).then(({ data }) => {
        const { payrollCommission, personalPayrollAllowance, groupPayrollAllowance, ...overview } =
          data;
        setOverviewDetails(overview);
        setTabDetails({
          payrollCommission,
          personalPayrollAllowance,
          groupPayrollAllowance,
        });
        dispatch({ type: "LOADING_END" });
      });
    } catch (error) {
      dispatch({ type: "LOADING_END" });
      console.error(error);
    }
  };

  useEffect(() => {
    fetchContractDetails();
  }, []);

  return (
    <div className="popup-body no-padding contract-details">
      {!state.loading && (
        <>
          <Overview details={overviewDetails} />
          <Tabs tabDetails={tabDetails} />
        </>
      )}
    </div>
  );
};

const Overview = memo(({ details }: any) => {
  const convertRegDt = () => {
    const regDt = new Date(details?.regDt);
    const hour = timeFormat(details?.regDt?.split("T")[1]);

    return `${changeDateFormat(regDt.format().toString(), true)} (${getDwk(regDt.getDay())}) ${
      hour.ampm
    } ${hour.time}`;
  };
  return (
    <div className="overview">
      <div>
        {convertRegDt()}
        <span className="divider" />
        {details?.regCoachName}
      </div>

      <div className="section">
        <span>급여기간</span>
        <span>{`${changeDateFormat(details?.startDt, true)} ~ ${changeDateFormat(
          details?.endDt,
          true
        )}`}</span>
      </div>

      <div className="section">
        <span>기본급</span>
        <span>{moneyFormatter(details?.basePay)}</span>
      </div>

      <div className="section">
        <span>공제율</span>
        <span>{`${details?.deductionRate}%`}</span>
      </div>
    </div>
  );
});

export default ContractDetails;
